import React from "react";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {Link} from 'react-router-dom';

function CollaborativeWorkingAndLearningSpaces() {

  return (
    <div className="LearningSpace">
      <section className="inner-banner banner-align">
        <img className="img-fluid" src="./assets/img/innerbanner/explore.jpg" alt="" />
      </section>
      <section className='information-common' id="ExploreLibrary">
        <div className='container'>
          <div className='information-content'>
            <h2>Using the Library/Explore</h2>
            <p>The following collaborative spaces are available at the library.</p>
          </div>
          <Row>
                <Col lg={5} sm={6}>
                <div className="floating-Side-wrap">
                    <div className="floating-Side">
                        <div className="right-tab-collab">
                        <div className="flex-column nav nav-pills">
                                <div className="nav-item">
                                    <Link as={Link} to="/CollaborativeWorkingAndLearningSpaces" className='nav-link active'>
                                    Collaborative Working and Learning Spaces
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/ComputerAndTechnology" className='nav-link'>
                                    Computer And Technology
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/PrintingScanningAndPhotocopying" className='nav-link'>
                                    Printing Scanning And Photocopying
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/LibraryService" className='nav-link'>
                                    Library Service
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/MakerSpace" className='nav-link'>
                                    Maker Space
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </Col>
                <Col lg={7} sm={6}>
                <div className="collaboration-hover">
                    <img className="img-fluid" src="./assets/img/learningspaces/CollaborativeWorkingAndLearningSpaces.jpg" alt="" />
                    <h6>Information Commons</h6>
                    <p>Information Commons located on the ground floor houses collaborative learning and socializing spaces including a lounge, mediascape and group seating spaces. Makerspace for creative work and expression is also available at the library. Maker items, including little bits, snap circuits, 3D pens, stationery items for printing on curio printer, etc., are issued to the students.</p>
                    <h6>Discussion Zone</h6>
                    <p>Opposite to front desk on the first floor, the discussion area is available for collaborative work and discussion.</p>
                    <h6>One-on-one Study Zone</h6>
                    <p>For facilitating one-on-one study and discussion, study tables with chairs are available opposite to library offices.</p>
                    <h6>Discussion Rooms</h6>
                    <p>There are 7 discussion rooms equipped with LCD TVs for discussing projects and brainstorming innovative ideas. The discussion rooms can be reserved through the first floor front desk counter on a first come first serve basis. The guidelines and procedure for the issuance of discussion rooms are available here.</p>
                    <h6>Dawood Habib Yohsin Hall</h6>
                    <p>For individual, quiet study and reflection, Yohsin Hall is available with a seating capacity of approximately 50 students.</p>
                </div>
                </Col>
            </Row>
        </div>
      </section>


    </div>
  );
}

export default CollaborativeWorkingAndLearningSpaces;